/**
 * Algolia Instantsearch with Autocomplete/Suggestions
 *
 */

import { unescape } from 'lodash'
import {autocomplete, getAlgoliaResults} from '@algolia/autocomplete-js'
import algoliasearch from 'algoliasearch'
import instantsearch from 'instantsearch.js'

import historyRouter from 'instantsearch.js/es/lib/routers/history'
import {
  connectSearchBox,
  connectSortBy
} from 'instantsearch.js/es/connectors'

import {
  searchBox,
  hierarchicalMenu,
  hits,
  pagination,
  refinementList,
  currentRefinements,
  clearRefinements,
  sortBy,
  configure

} from 'instantsearch.js/es/widgets'

const coursesAlgoliaInstantSearch = ($) => {

  if (!window.Tangible) return
  const ajax = window.Tangible.ajax
  const ajaxConfig = window.Tangible.ajaxConfig
  const tangibleSelect = window.Tangible.Select

  const tgblPEFrontend_json = window.atob(tgblPEFrontend_e)
  const tgblPEFrontend = jQuery.parseJSON(tgblPEFrontend_json)
  const LOCALIZED = tgblPEFrontend.localized

  //console.log(tgblPEFrontend)

  const facetMapping = {

    // current refinement
    'taxonomies.ld_course_tag': LOCALIZED.course_tag,
    'course_type': LOCALIZED.course_type,
    'course_difficulty': LOCALIZED.course_difficulty,
    'course_target_role': LOCALIZED.course_target_role,
    'post_author.display_name': LOCALIZED.course_author,

    // refinement list

    //course_type
    'tutorial': LOCALIZED.tutorial,
    'webinar': LOCALIZED.webinar,
    'course': LOCALIZED.course,
    'tool': LOCALIZED.tool,
    'preview': LOCALIZED.preview,
    'consulting': LOCALIZED.consulting,
    'lab': LOCALIZED.lab,
    'courselab': LOCALIZED.courselab,
    'testlab': LOCALIZED.testlab,
    'news': LOCALIZED.news,
    'recording': LOCALIZED.recording,

    //course_target_role
    'admin': LOCALIZED.admin,
    'designer': LOCALIZED.designer,
    'operator': LOCALIZED.operator,

    // course_difficulty
    'basic': LOCALIZED.basic,
    'intermediate': LOCALIZED.intermediate,
    'advanced': LOCALIZED.advanced,

    // clear refinements

    'clear_refinements': LOCALIZED.clear_refinements,
    'no_refinements': LOCALIZED.no_refinements,

    //course status  in_progress, not_started, completed
    'not_started': LOCALIZED.not_started,
    'in_progress': LOCALIZED.in_progress,
    'completed': LOCALIZED.completed,

    // misc
    'author_from': LOCALIZED.author_from,
  }

  let INSTANT_SEARCH_INDEX_NAME = tgblPEFrontend.pe_algolia_index
  let autocomplete_rendered = false
  const virtualSearchBox = connectSearchBox(() => {})
  const instantSearchRouter = historyRouter()

  // Return the InstantSearch index UI state.
  function getInstantSearchUiState() {
    const uiState = instantSearchRouter.read()
    return (uiState && uiState[INSTANT_SEARCH_INDEX_NAME]) || {}
  }
  
  const initialSearchPageState = instantSearchRouter.read()


  // Global object
  window.AlgoliaInstantSearch = {}

  $(document).ready(function () {
    window.AlgoliaInstantSearch.constructor()
  })

  window.AlgoliaInstantSearch = {

    // initialize the code
    constructor: function () {

      window.PEFavoritesFunctions.saveToFavorites()

      const $_this = this

      const tgbl_instantsearch_container__js= $('.tgbl-instantsearch-container--js')
      if(tgbl_instantsearch_container__js.length) {
        this.algoliaSearch($_this)
        this.toggleStatusVisibility($_this)
        this.switchGridTableButton($_this)
        this.onPopstateCorrection($_this,INSTANT_SEARCH_INDEX_NAME)
      }
    },


    algoliaSearch: function($_this, search_index) {

      const container = $('.tgbl-instantsearch-container--js')
      const user_saved_favorites = container.attr('data-user_saved_favorites')
      const user_enrolled_courses_data = container.attr('data-user_enrolled_courses_data')
      const user_id = container.attr('data-user_id') ? container.attr('data-user_id') : 0
      const is_admin = container.attr('data-is_admin') ? container.attr('data-is_admin') : 0

      // if we have replica index from sortby
      INSTANT_SEARCH_INDEX_NAME = search_index != undefined ? search_index : INSTANT_SEARCH_INDEX_NAME

      const algoliaClient = algoliasearch(
        window.atob(tgblPEFrontend.EAID),
        window.atob(tgblPEFrontend.EAK)
      )

      const index = algoliaClient.initIndex(INSTANT_SEARCH_INDEX_NAME);

      const searchClient = {
        ...algoliaClient,
        search(requests) {
          const newRequests = requests.map((request) => {
            // Test for empty string and change `analytics` request parameter to `false`
            if(!request.params.query || request.params.query.length === 0) {
              request.params.analytics = false;
            }
            return request;
          });



          return algoliaClient.search(newRequests);
        },
      };

      const search = instantsearch({
        searchClient,
        indexName: INSTANT_SEARCH_INDEX_NAME,
        routing: instantSearchRouter,
      })




      /***************
       *
       * INSTANTSEARCH
       *
       ****************/

      let status_filters = $_this.getStatusFilters($_this)
      let filters = $_this.algoliaSearchFilters($_this, status_filters, user_id, is_admin)

      /***************
      CUSTOM SORTBY
      ****************/

      // Create the render function
      const renderSortBy = (renderOptions, isFirstRender) => {

          //console.log(renderOptions)
        const {
          options,
          currentRefinement,
          refine,
          widgetParams,
          // `canRefine` is only available from v4.45.0
          // Use `hasNoResults` in earlier minor versions.
          canRefine,
        } = renderOptions;

        if (isFirstRender) {
          const select = document.createElement('select')

          select.addEventListener('change', event => {
            const search_index = event.target.value

            //console.log('filters -- ', filters)
            renderOptions.instantSearchInstance.helper.state.filters = filters
            refine(event.target.value);
          })
          widgetParams.container.appendChild(select)
        }

        const select = widgetParams.container.querySelector('select')
        select.disabled  = !canRefine

        select.innerHTML = `          
          ${options
            .map(
              option => `
                <option
                  value="${option.value}"
                  ${option.value === currentRefinement ? 'selected' : ''}
                >
                  ${option.label}
                </option>
              `
              ).join('')
            }`
      }

      // Create the custom widget
      const customSortByTitle = connectSortBy(renderSortBy);
      const customSortByAuthor = connectSortBy(renderSortBy);
      const customSortByType = connectSortBy(renderSortBy);
      const customSortByRole = connectSortBy(renderSortBy);
      const customSortByDate = connectSortBy(renderSortBy);

      if(!autocomplete_rendered && tgblPEFrontend.algolia_show_sortby === 'yes'){
        search.addWidgets([

        customSortByTitle({
          container: $('#sort-by-title')[0],
          items: [
            { label: LOCALIZED.sort_by_title_asc, value: INSTANT_SEARCH_INDEX_NAME }, //wp_posts_sfwd-courses
            { label: LOCALIZED.sort_by_title_desc, value: 'course_title_desc' },
          ],
        }),
        customSortByAuthor({
          container: $('#sort-by-author')[0],
          items: [
            { label: LOCALIZED.sort_by_author_asc, value: 'course_auth_asc' },
            { label: LOCALIZED.sort_by_author_desc, value: 'course_auth_desc' },
          ],
        }),
        customSortByType({
          container: $('#sort-by-type')[0],
          items: [
            { label: LOCALIZED.sort_by_type_asc, value: 'course_type_asc' },
            { label: LOCALIZED.sort_by_type_desc, value: 'course_type_desc' },
          ],
        }),
        customSortByRole({
          container: $('#sort-by-role')[0],
          items: [
            { label: LOCALIZED.sort_by_role_asc, value: 'course_role_asc' },
            { label: LOCALIZED.sort_by_role_desc, value: 'course_role_desc' },
          ],
        }),
        customSortByDate({
          container: $('#sort-by-published')[0],
          items: [
            { label: LOCALIZED.sort_by_published_asc, value: 'course_date_asc' },
            { label: LOCALIZED.sort_by_published_desc, value: 'course_date_desc' },
          ],
        }),
        ])
      }

      /***************
       ADD AIS WIDGETS
       ****************/

      search.addWidgets([

        configure({
          filters: filters,
          facetFilters: [

          ]
        }),

         // course_tags
        refinementList({
          container: '#refinement-list-course-tag',
          attribute: 'taxonomies.ld_course_tag',
          limit: 25,
          cssClasses: {
            root: 'tgbl-refinement-list tgbl-facet-course-type',
            list: [
              'tgbl-refinement-list-list',
              'tgbl-refinement-list-list--subclass',
            ],
            item: 'tgbl-refinement-list-item',
            selectedItem: 'tgbl-refinement-list-selected-item',
            label: 'tgbl-refinement-list-label',
            labelText: 'tgbl-refinement-list-label-text',
            checkbox: 'tgbl-refinement-list-checkbox',
            count: 'tgbl-refinement-list-count', 
          },

          transformItems(items) {
            return items.map(item => ({
              ...item,
              label: facetMapping[item.label] ?? item.label,
              highlighted: facetMapping[item.label] ?? item.label,
            }))
          },
        }),

        // course_type
        refinementList({
          container: '#refinement-list-course-type',
          attribute: 'course_type',
          limit: 25,
          cssClasses: {
            root: 'tgbl-refinement-list tgbl-facet-course-type',
            list: [
              'tgbl-refinement-list-list',
              'tgbl-refinement-list-list--subclass',
            ],
            item: 'tgbl-refinement-list-item',
            selectedItem: 'tgbl-refinement-list-selected-item',
            label: 'tgbl-refinement-list-label',
            labelText: 'tgbl-refinement-list-label-text',
            checkbox: 'tgbl-refinement-list-checkbox',
            count: 'tgbl-refinement-list-count',
          },

          transformItems(items,results) {
            return items.map(item => ({
              ...item,
              label: facetMapping[item.label] ?? item.label,
              highlighted: facetMapping[item.label] ?? item.label,
            }))
          },
        }),

        // course_target_role
        refinementList({
          container: '#refinement-list-course-target-role',
          attribute: 'course_target_role',
          limit: 25,
          cssClasses: {
            root: 'tgbl-refinement-list tgbl-facet-course-target-role',
            list: [
              'tgbl-refinement-list-list',
              'tgbl-refinement-list-list--subclass',
            ],
            item: 'tgbl-refinement-list-item',
            selectedItem: 'tgbl-refinement-list-selected-item',
            label: 'tgbl-refinement-list-label',
            labelText: 'tgbl-refinement-list-label-text',
            checkbox: 'tgbl-refinement-list-checkbox',
            count: 'tgbl-refinement-list-count',
          },

            transformItems(items) {
              return items.map(item => ({
                ...item,
                label: facetMapping[item.label] ?? item.label,
                highlighted: facetMapping[item.label] ?? item.label,
              }))
            },
          }),

        // course_difficulty
        refinementList({
          container: '#refinement-list-course-difficulty',
          attribute: 'course_difficulty',
          limit: 25,
          cssClasses: {
            root: 'tgbl-refinement-list tgbl-facet-course-difficulty',
            list: [
              'tgbl-refinement-list-list',
              'tgbl-refinement-list-list--subclass',
            ],
            item: 'tgbl-refinement-list-item',
            selectedItem: 'tgbl-refinement-list-selected-item',
            label: 'tgbl-refinement-list-label',
            labelText: 'tgbl-refinement-list-label-text',
            checkbox: 'tgbl-refinement-list-checkbox',
            count: 'tgbl-refinement-list-count',  
          },

          transformItems(items) {
            return items.map(item => ({
              ...item,
              label: facetMapping[item.label] ?? item.label,
              highlighted: facetMapping[item.label] ?? item.label,
            }))
          },
        }),

        // post_author.display_name
        refinementList({
          container: '#refinement-list-post-author',
          attribute: 'post_author.display_name',
          limit: 25,
          cssClasses: {
            root: 'tgbl-refinement-list tgbl-facet-author',
            list: [
              'tgbl-refinement-list-list',
              'tgbl-refinement-list-list--subclass',
            ],
            item: 'tgbl-refinement-list-item',
            selectedItem: 'tgbl-refinement-list-selected-item',
            label: 'tgbl-refinement-list-label',
            labelText: 'tgbl-refinement-list-label-text',
            checkbox: 'tgbl-refinement-list-checkbox',
            count: 'tgbl-refinement-list-count',
          },
        }),


        // current refinements
        currentRefinements({
          container: '#current-refinements',
          cssClasses: {
            root: 'tgbl-current-refinements',
            noRefinementRoot: 'tgbl-current-refinements--no-refinement',
            list: [
              'tgbl-current-refinements-list',
              'tgbl-current-refinements-list--subclass',
            ],
            item: 'tgbl-current-refinements-item',
            label: 'tgbl-current-refinements-label',
            category: 'tgbl-current-refinements-category',
            categoryLabel: 'tgbl-current-refinements-category-label',
            delete: 'tgbl-current-refinements-delete',
          },

          transformItems: function (items) {
            //console.log(items)
            $.each(items, function (index, item) {
              //console.log(item.label)
              item.label = facetMapping[item.label] ?? item.label
              $.each(item.refinements, function (index, r) {
                //console.log(r.attribute)
                r.label = r.value
                if(r.attribute != 'post_author.display_name' && r.attribute != 'taxonomies.ld_course_tag') r.label = facetMapping[r.label]
              })
            })
            return items
          },
        }),

        // clear refinements
        clearRefinements({
          container: '#clear-refinements',
          cssClasses: {
            root: 'tgbl-clear-refinements',
            disabledButton: 'tgbl-clear-refinements-button-disabled',
            button: [
              'tgbl-clear-refinements-button',
              'tgbl-clear-refinements-button--subclass',
            ],
          },
          templates: {
            resetLabel({hasRefinements}, {html}) {
              return html`
                <span>${hasRefinements ? facetMapping.clear_refinements : facetMapping.no_refinements}</span>`;
            },
          },
        }),

        virtualSearchBox({}),

        hierarchicalMenu({
          container: '#categories',
          attributes: ['taxonomies_hierarchical.ld_course_category.lvl0'],
        }),

        hits({
          container: '#hits',
          cssClasses: {
            root: 'tgbl-search-results-wrap',
            list: ['archive-layouts--js', 'archive-layout'],
            //list: ['archive-layouts--js', 'archive-layout','archive-layout-table'],
            item: ['MyCustomItem', 'pec-item-card'],
            //item: ['MyCustomItem'],
          },
          templates: {
            //item:
            item(hit, {html, components, sendEvent}) {

            //  console.log('111--- ', hit.taxonomies)

              const uecd_obj = jQuery.parseJSON(user_enrolled_courses_data)
              let course_status = 'not_started'
              let course_percentage = 0
              let user_enrolled = 'no'
              //let status_display_style = ' style="display:inherit" '

              if (hit.post_id in uecd_obj) {
                course_status = uecd_obj[hit.post_id]['course_status_slug']
                if ($.inArray(course_status, status_filters) !== -1) {
                }
                user_enrolled = 'yes'
                course_percentage = uecd_obj[hit.post_id]['course_steps_percentage']
              }

              //  ['not_started', 'in_progress']
              //const class_status = 'course-' + course_status
              const class_enrolled = 'user-enrolled-' + user_enrolled

              const usf_arr = []
              if (user_saved_favorites != undefined && user_saved_favorites) {
                const usf_obj = jQuery.parseJSON(user_saved_favorites)
                $.each(usf_obj, function (k, v) {
                  usf_arr.push(parseInt(v))
                })
              }

              let saved = 0
              if ($.inArray(hit.post_id, usf_arr) !== -1) {
                saved = 1
              }

              const saved_class = saved ? ' favorite-item saved' : ' favorite-item not-saved'
              let not_logged_in_class = ''
              let button_text = ''
              let button_screen_reader_text = ''

              if (user_id) {
                if (saved) {
                  button_text = LOCALIZED.remove_from_fav
                  button_screen_reader_text = LOCALIZED.remove_from_fav_sr
                } else {
                  button_text = LOCALIZED.add_to_fav
                  button_screen_reader_text = LOCALIZED.add_to_fav_sr
                }
              } else {
                not_logged_in_class = ' tgbl-must-log-in';
                if (saved) {
                  button_text = LOCALIZED.not_logged_remove_from_fav
                  button_screen_reader_text = LOCALIZED.not_logged_remove_from_fav_sr
                } else {
                  button_text = LOCALIZED.not_logged_add_to_fav
                  button_screen_reader_text = LOCALIZED.not_logged_add_to_fav_sr
                }
              }

              const turl = (hit.images.thumbnail != undefined) ? hit.images.thumbnail.url : ''
              const murl = (hit.medium_img_url != undefined) ? hit.medium_img_url : ''

              let category = ''
              let taxonomies_ld_course_category = hit.taxonomies.ld_course_category
              if (taxonomies_ld_course_category !== undefined && taxonomies_ld_course_category !== null) {
                category = taxonomies_ld_course_category[0]
              }


              const course_type = hit.course_type
              const course_live_date = hit.course_live_date
              const course_live_time = hit.course_live_time
              const has_date_time = !!((category === 'Webinar' || category === 'Vorschau') && course_live_date)

              let is_course = 0
              if (taxonomies_ld_course_category !== undefined && taxonomies_ld_course_category !== null) {
                if ($.inArray('Kurs', taxonomies_ld_course_category) !== -1) {
                  is_course = 1
                }
              }
              const lessons_number = hit.course_lessons_number
              const quizzes_number = hit.course_quizzes_number
              const has_lessons_number = is_course && lessons_number !== 0
              const has_quizzes_number = is_course && quizzes_number !== 0

              //console.log(hit.taxonomies.ld_course_category, is_course, has_lessons_number, has_quizzes_number)

              // CSS classes with the '--js' suffix should be preserved for js functionality!
              return html`
                <div class="pec-item  ${class_enrolled}">
                  <div class="pec-item-wrapper--js pec-item-wrapper pec-card">

                    <div class="pec-item-header--js pec-item-header py-1 px-2 border-bottom">
                      <div class="pec-target-role pec-target-role-${hit.course_target_role}">
                        <span class="icon-circle">
                          <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M1.8 19.4c0-3 3-5.6 6.8-5.6h6.8c3.7 0 6.8 2.5 6.8 5.6v1c0 1.4-1.6 2.7-3.4 2.7H5.2c-1.8 0-3.4-1.3-3.4-2.8v-1ZM7 6a5 5 0 1 1 10 0A5 5 0 0 1 7 6Z"
                                  fill="currentcolor"></path>
                          </svg>
                        </span>
                        ${facetMapping[hit.course_target_role]}
                      </div>

                      <div
                        class="tgbl-favorite-actions favorite-actions--js  ${not_logged_in_class}  ${saved_class} "
                        data-post_id="${hit.post_id}"
                        data-user_id="${user_id}"
                        data-saved="${saved}"
                        data-tooltip_favorites="${button_text}"
                      >
                        <button class="tgbl-favorite-action tgbl-favorite-icon favorite-icon--js" style="cursor:pointer;">
                          <span class="text text--js">
                            <span class="tgbl-favorite-icon-inactive">
                              <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99535 0.667969C8.24911 0.667969 8.48087 0.812036 8.59317 1.03959L10.4953 4.89382L14.7483 5.51019C14.9996 5.54661 15.2083 5.72258 15.2867 5.96406C15.3652 6.20554 15.2996 6.47059 15.1177 6.64768L12.0357 9.64767L12.7624 13.8839C12.8053 14.1341 12.7024 14.387 12.497 14.5362C12.2915 14.6853 12.0192 14.7048 11.7946 14.5864L7.99966 12.5867L4.19559 14.5867C3.97097 14.7048 3.69879 14.6851 3.49349 14.536C3.28819 14.3868 3.18537 14.134 3.22828 13.8839L3.95497 9.64767L0.873004 6.64768C0.691073 6.47059 0.625524 6.20554 0.703941 5.96406C0.782358 5.72258 0.991127 5.54661 1.24239 5.51019L5.49537 4.89382L7.39752 1.03959C7.50983 0.812036 7.74158 0.667969 7.99535 0.667969ZM7.99535 2.84102L6.53584 5.79834C6.43869 5.99519 6.25087 6.13159 6.03363 6.16308L2.77228 6.63573L5.13635 8.93692C5.29371 9.09009 5.36554 9.31092 5.32841 9.52735L4.77081 12.7779L7.68977 11.2432C7.88419 11.141 8.11648 11.1411 8.31081 11.2435L11.2196 12.7763L10.6623 9.52735C10.6251 9.31092 10.697 9.09009 10.8543 8.93692L13.2184 6.63573L9.95706 6.16308C9.73982 6.13159 9.552 5.99519 9.45485 5.79834L7.99535 2.84102Z" fill="currentcolor"/>
                              </svg>
                            </span>

                            <span class="tgbl-favorite-icon-active">
                              <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99536 0.69458C8.25297 0.69458 8.48753 0.837066 8.59783 1.06056L10.5032 4.92128L14.7522 5.53708C15.0001 5.57302 15.2061 5.73945 15.2853 5.96783C15.3644 6.19622 15.3034 6.44794 15.1274 6.61932L12.0323 9.63203L12.7632 13.8926C12.8046 14.1343 12.6988 14.3774 12.4905 14.5189C12.2823 14.6605 12.0082 14.6755 11.7846 14.5576L7.99966 12.5631L4.20559 14.5579C3.98193 14.6755 3.70798 14.6603 3.49991 14.5188C3.29185 14.3772 3.18611 14.1341 3.22755 13.8926L3.95841 9.63203L0.863365 6.61932C0.687304 6.44794 0.626295 6.19622 0.705463 5.96783C0.784631 5.73945 0.990587 5.57302 1.23851 5.53708L5.48753 4.92128L7.39289 1.06056C7.50319 0.837066 7.73775 0.69458 7.99536 0.69458Z" fill="currentcolor"/>
                              </svg>
                            </span>
                          </span>

                          <span class="screen-reader-text  screen-reader--js">
                            ${button_screen_reader_text}
                          </span>
                        </button>
                      </div>
                    </div>

                    <div class="pec-item-image">
                      <img src="${murl}"/>
                      <div class="pec-item-button">
                        <i class="fa fa-chevron-right"></i>
                      </div>
                    </div>

                    <div class="pec-item-content p-2">
                      <div class="pec-item-meta">
                        
                        <div class="pec-badge pec-badge-accent pec-content-type-${hit.course_type}">
                          <span class="pec-badge-text">${facetMapping[hit.course_type]}</span>
                        </div>
                        
                      <!-- Lessons number-->                        
                        <div class="pec-badge" style=${has_lessons_number ? '' : 'display:none'}>
                          <span class="pec-badge-icon">
                            <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.4 3.7v9a.7.7 0 0 0 .5.6.7.7 0 0 0 .4 0 5.3 5.3 0 0 1 5.4 0 .7.7 0 0 0 .6 0 5.3 5.3 0 0 1 5.4 0 .7.7 0 0 0 .8-.2.7.7 0 0 0 .2-.4V4a.7.7 0 0 0-.4-.6A6.7 6.7 0 0 0 8 3.2a6.7 6.7 0 0 0-6.4.2l-.2.3Zm12 .7a5.3 5.3 0 0 0-4.7 0v7.2a6.7 6.7 0 0 1 4.6 0V4.4Zm-6 0v7.2a6.7 6.7 0 0 0-4.7 0V4.4a5.3 5.3 0 0 1 4.6 0Z" fill=${has_lessons_number ? '#8F8E8E' : 'none'}></path>
                            </svg>
                          </span>
                          <span class="pec-badge-text">${lessons_number}</span>
                        </div>

                        <!-- Quizzes number-->
                        <div class="pec-badge" style=${has_quizzes_number ? '' : 'display:none'}>
                          <span class="pec-badge-icon">
                            <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M3 2.4c.3-.3.6-.4 1-.4h7.3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.7v.7a.7.7 0 0 1-1.4 0V14H4a1.3 1.3 0 0 1-1.3-1.3V3.3c0-.3.1-.7.4-1Zm3.7 10.3h4.6a.7.7 0 0 0 .7-.7V4a.7.7 0 0 0-.7-.7H6.7v9.4ZM5.3 3.3v9.4H4V3.3h1.3Zm2.7 2c0-.3.3-.6.7-.6H10A.7.7 0 1 1 10 6H8.7a.7.7 0 0 1-.7-.7Zm.7 2a.7.7 0 1 0 0 1.4H10a.7.7 0 1 0 0-1.4H8.7Z" fill=${has_quizzes_number ? '#8F8E8E' : 'none'}></path>
                            </svg>
                          </span>
                          <span class="pec-badge-text">${quizzes_number}</span>
                        </div>

                        <!-- Live date/time-->
                        <div class="pec-badge" style=${has_date_time ? '' : 'display:none'}>
                          <span class="pec-badge-icon">
                            <svg width="1em" height="1em" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7 2a.7.7 0 0 0-1.4 0v.7h-4V2A.7.7 0 0 0 4 2v.7h-.7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2H8a.7.7 0 1 0 0-1.4H3.3a.7.7 0 0 1-.6-.6V8h10c.3 0 .6-.3.6-.7V4.7a2 2 0 0 0-2-2h-.6V2ZM12 6.7v-2a.7.7 0 0 0-.7-.7h-.6v.7a.7.7 0 0 1-1.4 0V4h-4v.7a.7.7 0 0 1-1.3 0V4h-.7a.7.7 0 0 0-.6.7v2H12Zm0 2a3.3 3.3 0 1 0 0 6.6 3.3 3.3 0 0 0 0-6.6Zm-.7 3.3v-1.9a2 2 0 1 0 2.6 2.6H12a.7.7 0 0 1-.7-.7Zm1.4-.7h1.2a2 2 0 0 0-1.2-1.2v1.2Z" fill=${has_date_time ? '#8F8E8E' : 'none'}>                              
                              </path>
                            </svg>                        
                             
                            </span>
                            <span class="pec-badge-text">
                              ${course_live_date ? course_live_date : ''} 
                              ${course_live_time ? ', '+course_live_time : ''}                             
                          </span>
                        </div>

                        <!-- Difficulty -->
                        <div class="pec-badge">
                          <span class="pec-badge-icon">
                            <span class="icon-difficulty ${hit.course_difficulty}">
                              <div></div>
                              <div></div>
                              <div></div>
                            </span>
                          </span>
                          <span class="pec-badge-text">
                            ${facetMapping[hit.course_difficulty]}
                          </span>
                        </div>
                      </div>

                      <div class="pec-item-title mb-1">
                        <a href="${hit.permalink}">${components.Highlight({
                          hit,
                          attribute: 'post_title_html_decoded',
                          highlightedTagName: 'tgbl-mark',
                        })}</a>
                      </div>

                      <div class="pec-item-author">                        
                        <span class="pec-avatar text-xxs">
                          <img alt="" src="${hit.author_avatar_url}" class="avatar avatar-48 photo" loading="lazy"
                               width="48" height="48"/>
                        </span>
                        <div>                          
                          <span class="text-bold">
                            ${hit.post_author.display_name}
                          </span>
                        </div>
                      </div>

                      <div class="pec-item-date">
                        ${hit.date_formatted}
                      </div>
                    </div>

                    <div class="pec-item-footer--js pec-item-footer mt-auto p-2">

                      <div class="pec-progress">
                        <div class="pec-progress-bar-line">
                          <div class="pec-progress-text">
                            <span>
                            ${facetMapping[course_status]}
                            </span>
                            <span class="ml-auto">
                              ${course_percentage}%
                            </span>
                          </div>
                          <div class="pec-progress-bar-line-inner">
                            <div class="pec-progress-bar-line-fill" style="width: ${course_percentage}%"></div>
                          </div>
                        </div>
                        <div class="pec-progress-bar-circle">
                          <div class="pec-progress-bar-circle-inner"
                               style="background-image: conic-gradient( #6DCE45 ${course_percentage}%, 0,transparent 360deg); border-radius: 50%;  width: 20px; height: 20px;"></div>
                          <div class="pec-progress-text mr-1">
                            ${course_percentage}%
                          </div>
                        </div>
                      </div>

                      <div
                        class="tgbl-favorite-actions favorite-actions--js ${not_logged_in_class}  ${saved_class}"
                        data-post_id="${hit.post_id}"
                        data-user_id="${user_id}"
                        data-saved="${saved}"
                        data-tooltip_favorites="${button_text}"
                      >                     
                        <button class="tgbl-favorite-action tgbl-favorite-icon favorite-icon--js" style="cursor:pointer;">
                          <span class="text text--js">
                            <span class="tgbl-favorite-icon-inactive">
                              <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99535 0.667969C8.24911 0.667969 8.48087 0.812036 8.59317 1.03959L10.4953 4.89382L14.7483 5.51019C14.9996 5.54661 15.2083 5.72258 15.2867 5.96406C15.3652 6.20554 15.2996 6.47059 15.1177 6.64768L12.0357 9.64767L12.7624 13.8839C12.8053 14.1341 12.7024 14.387 12.497 14.5362C12.2915 14.6853 12.0192 14.7048 11.7946 14.5864L7.99966 12.5867L4.19559 14.5867C3.97097 14.7048 3.69879 14.6851 3.49349 14.536C3.28819 14.3868 3.18537 14.134 3.22828 13.8839L3.95497 9.64767L0.873004 6.64768C0.691073 6.47059 0.625524 6.20554 0.703941 5.96406C0.782358 5.72258 0.991127 5.54661 1.24239 5.51019L5.49537 4.89382L7.39752 1.03959C7.50983 0.812036 7.74158 0.667969 7.99535 0.667969ZM7.99535 2.84102L6.53584 5.79834C6.43869 5.99519 6.25087 6.13159 6.03363 6.16308L2.77228 6.63573L5.13635 8.93692C5.29371 9.09009 5.36554 9.31092 5.32841 9.52735L4.77081 12.7779L7.68977 11.2432C7.88419 11.141 8.11648 11.1411 8.31081 11.2435L11.2196 12.7763L10.6623 9.52735C10.6251 9.31092 10.697 9.09009 10.8543 8.93692L13.2184 6.63573L9.95706 6.16308C9.73982 6.13159 9.552 5.99519 9.45485 5.79834L7.99535 2.84102Z" fill="currentcolor"/>
                              </svg>
                            </span>

                            <span class="tgbl-favorite-icon-active">
                              <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99536 0.69458C8.25297 0.69458 8.48753 0.837066 8.59783 1.06056L10.5032 4.92128L14.7522 5.53708C15.0001 5.57302 15.2061 5.73945 15.2853 5.96783C15.3644 6.19622 15.3034 6.44794 15.1274 6.61932L12.0323 9.63203L12.7632 13.8926C12.8046 14.1343 12.6988 14.3774 12.4905 14.5189C12.2823 14.6605 12.0082 14.6755 11.7846 14.5576L7.99966 12.5631L4.20559 14.5579C3.98193 14.6755 3.70798 14.6603 3.49991 14.5188C3.29185 14.3772 3.18611 14.1341 3.22755 13.8926L3.95841 9.63203L0.863365 6.61932C0.687304 6.44794 0.626295 6.19622 0.705463 5.96783C0.784631 5.73945 0.990587 5.57302 1.23851 5.53708L5.48753 4.92128L7.39289 1.06056C7.50319 0.837066 7.73775 0.69458 7.99536 0.69458Z" fill="currentcolor"/>
                              </svg>
                            </span>
                          </span>
                          
                          <span class="screen-reader-text  screen-reader--js">
                            ${button_screen_reader_text}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              `
            }
          },
        }),

        pagination({
          container: '#pagination',
          cssClasses: {
            root: 'tgbl-is-pagination',
            list: [
              'tgbl-is-pagination-list',
              'tgbl-is-pagination-list--subclass',
            ],
            item: 'tgbl-is-pagination-item',
            firstPageItem: 'tgbl-is-first-page-item',
            lastPageItem: 'tgbl-is-last-page-item',
            previousPageItem: 'tgbl-is-previous-page-item',
            nextPageItem: 'tgbl-is-next-page-item',
            pageItem: 'tgbl-is-page-item',
            selectedItem: 'tgbl-is-selected-item',
            disabledItem: 'tgbl-is-disabled-item',
            link: 'tgbl-is-pagination-link',
          },
        }),
      ]) // END Search add widgets


      search.start()

      //console.log(search.helper)

      const router = instantSearchRouter.read()
      const searchPageState = router && router[INSTANT_SEARCH_INDEX_NAME] || {}

      // if we have status filters active set page to 1
      if(status_filters != undefined && status_filters.length){
        //console.log(searchPageState)
        setInstantSearchUiState(searchPageState)
      }


      /***************
       AUTOCOMPLETE
       ****************/

      // Set the InstantSearch index UI state from external events.
      function setInstantSearchUiState(indexUiState) {

        search.setUiState(uiState => ({
          ...uiState,
          [INSTANT_SEARCH_INDEX_NAME]: {
            ...uiState[INSTANT_SEARCH_INDEX_NAME],
            // We reset the page when the search state changes.
            page: 1,
            ...indexUiState,
          },
        }))
      }

      if(!autocomplete_rendered){
        autocomplete_rendered=true
        autocomplete({
          container: '#tgbl-pe-algolia-autocomplete',
          //plugins: [querySuggestionsPlugin],
          //detachedMediaQuery: 'none',
          //detachedMediaQuery: '',
          //detachedMediaQuery: "(max-width: 680px)",
          openOnFocus: true,
          initialState: {
            query: searchPageState.query || '',
          },
          onSubmit({state}) {
            setInstantSearchUiState({
              query: state.query
            })
          },
          onReset() {
            setInstantSearchUiState({query: ''})
          },
          onStateChange({prevState, state}) {
            if (prevState.query !== state.query) {
              setInstantSearchUiState({query: state.query})
              $_this.resetStatusFilters($_this)
            }
            //console.log('333--- ', filters)
          },
          getSources({query}) {
            return [{
              sourceId: INSTANT_SEARCH_INDEX_NAME,
              getItems() {
                return getAlgoliaResults({
                  searchClient,
                  queries: [
                    {
                      indexName: INSTANT_SEARCH_INDEX_NAME,
                      query,
                      params: {
                        filters:'course_users_enrolled:'+user_id,
                        //hitsPerPage: 5,
                        hitsPerPage: tgblPEFrontend.max_suggestions,
                        attributesToRetrieve: ['post_title', 'content'],
                        attributesToSnippet: ['post_title:10', 'content:25'],
                        snippetEllipsisText: '…',
                      },
                    },
                  ],
                });
              },
              getItemInputValue({item}) {
                //console.log(item)
                return item.post_title
              },
              templates: {
                item({item, components, html}) {
                  return html`
                    <div class="aa-ItemWrapper">
                      <div class="aa-ItemContent">
  
                        <div class="aa-ItemContentBody">
                          <div class="aa-ItemContentTitle">
                            ${components.Highlight({
                              hit: item,
                              attribute: 'post_title_html_decoded',
                            })}
                          </div>
                          <div class="aa-ItemContentDescription">
                            ${components.Snippet({
                              hit: item,
                              //attribute: 'content',
                              attribute: 'content',
                            })}
                          </div>
                        </div>
                        <div class="aa-ItemActions">
                          <button
                            class="aa-ItemActionButton aa-DesktopOnly aa-ActiveOnly"
                            type="button"
                            title="Select"
                          >
                            <svg
                              viewBox="0 0 24 24"
                              width="20"
                              height="20"
                              fill="currentColor"
                            >
                              <path
                                d="M18.984 6.984h2.016v6h-15.188l3.609 3.609-1.406 1.406-6-6 6-6 1.406 1.406-3.609 3.609h13.172v-4.031z"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>`;
                },
              },// end templates
            }]
          },

        }) // END AUTOCOMPLETE
      } // END if autocomplete rendered
    }, // END Algolia search function


    algoliaSearchFilters: function($_this, status_filters, user_id, is_admin) {

      let removeItem = 'favorites'

      let favorites_filter = ''
      if($.inArray(removeItem, status_filters) !==-1) {
        status_filters.splice($.inArray(removeItem, status_filters), 1)
        favorites_filter = 'favorites'
      }

      let apply_status_filters = ''

      if(status_filters != undefined && status_filters.length){
        $.each(status_filters, function(k,v){

          let logic_operator = ''

          if(status_filters.length != k+1){
            logic_operator =' OR '
          }
          apply_status_filters += 'course_users_'+v+':'+user_id+logic_operator;
        })
      }

      if(favorites_filter == 'favorites'){
        if(apply_status_filters){
          apply_status_filters = '('+apply_status_filters+')' + ' AND course_users_'+favorites_filter+':'+user_id
        } else{
          apply_status_filters = 'course_users_'+favorites_filter+':'+user_id
        }
      }

      if(!is_admin){
        if(apply_status_filters){
          apply_status_filters = apply_status_filters +' AND course_users_enrolled:'+user_id
        } else{
          apply_status_filters = apply_status_filters + 'course_users_enrolled:'+user_id
        }
      }

      return apply_status_filters
    },


    toggleStatusVisibility:function($_this) {

      const parent= $('.tgbl-instantsearch-container--js')
      const status_refinement= parent.find('#refinement-list-course-status')

      parent.on('click','#refinement-list-course-status input', function() {

        const router = instantSearchRouter.read()
        const uiState = router && router[INSTANT_SEARCH_INDEX_NAME] || {}

        //console.log(uiState)

        if(uiState && uiState.sortBy != undefined) {
          const s_index = instantSearchRouter.read()[INSTANT_SEARCH_INDEX_NAME].sortBy
          $_this.algoliaSearch($_this,s_index)
        } else{
          $_this.algoliaSearch($_this)
        }

        //console.log( 's_index', s_index )
      })
    },


    resetStatusFilters:function($_this) {
      const parent= $('.tgbl-instantsearch-container--js')
      const status_refinement= parent.find('#refinement-list-course-status')

      status_refinement.find('input').each(function(){
        const parent_li = $(this).parents('li')  //tgbl-refinement-list-selected-item
        if($(this).is(':checked')){
          $(this).prop(':checked',false)
          //$(this).parents('li.tgbl-refinement-list-item').removeClass('tgbl-refinement-list-selected-item')
          $(this).trigger('click')
          //console.log($(this).attr("checked"), $(this).prop(":checked"))
          parent_li.removeClass('tgbl-refinement-list-selected-item')
        }
      })
    },


    getStatusFilters:function($_this) {
      const parent = $('.tgbl-instantsearch-container--js')
      const status_refinement = parent.find('#refinement-list-course-status')
      let status_filters = []

      status_refinement.find('input').each(function(){
        const parent_li = $(this).parents('li')  //tgbl-refinement-list-selected-item
        if($(this).is(':checked')){
          status_filters.push($(this).val())
          parent_li.addClass('tgbl-refinement-list-selected-item')

        } else{
          parent_li.removeClass('tgbl-refinement-list-selected-item')
        }
      })
      return status_filters
    },


    switchGridTableButton:function() {

      const parent= $('.tgbl-pe-algolia-autocomplete-wrap--js')
      const switch_grid_button = parent.find('.grid-table-icon--js')

      switch_grid_button.on('click', function(e){

        const $this= $(this)
        const list_parent= parent.parents('.tgbl-instantsearch-container--js').find('.archive-layouts--js')

        if(!$this.hasClass('active-view--js')){
          parent.find('.grid-table-icon--js.active-view--js').removeClass('active-view--js')
          $this.addClass('active-view--js')
        }

        if($this.hasClass('table-view--js')){
          list_parent.addClass('archive-layout-table')
        } else{
          list_parent.removeClass('archive-layout-table')
        }
      })
    },


    onPopstateCorrection: function($_this, search_index) {

      const autocompletebox = $('.tgbl-pe-algolia-autocomplete-wrap--js').find('input')

      // Correct autocompletebox value on browser history button click
      $(window).on('popstate', function(event) {
        if(instantSearchRouter.read()[search_index] != undefined && instantSearchRouter.read()[search_index].query != undefined) {
          autocompletebox.val(instantSearchRouter.read()[INSTANT_SEARCH_INDEX_NAME].query)
        } else{
          autocompletebox.val('')
        }
        //console.log(autocompletebox.val())
      })
    },
  }
}

export { coursesAlgoliaInstantSearch }

